import { GraphQLModuleConfigurationRepository } from "@app/repositories/GraphQLRepositories/ModuleConfigurationRepository";
import { GetModuleConfigBackOfficeQueryVariables } from "@generated/client/graphql";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const moduleConfigurationRepository =
    new GraphQLModuleConfigurationRepository();

export const moduleConfigurationKeys = {
    all: () => ["moduleConfiguration"] as const,
    filtered: (filter: GetModuleConfigBackOfficeQueryVariables) =>
        [...moduleConfigurationKeys.all(), filter] as const,
};

export function useModuleConfiguration(
    input: GetModuleConfigBackOfficeQueryVariables,
) {
    const { data, isPending } = useQuery({
        queryKey: moduleConfigurationKeys.filtered(input),
        queryFn: () =>
            moduleConfigurationRepository.getModuleConfigBackOffice(input),
        enabled: !!input.tenantId,
    });
    return { moduleConfiguration: data?.moduleConfigBackOffice, isPending };
}

export const useActivateModule = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: moduleConfigurationRepository.activateModule,
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: moduleConfigurationKeys.all(),
            });
        },
    });
    return mutation;
};

export const useDeactivateModule = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: moduleConfigurationRepository.deactivateModule,
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: moduleConfigurationKeys.all(),
            });
        },
    });
    return mutation;
};
